<template>
        <div>
      <v-dialog
        v-model="confirmBox.visible"
        persistent
        width="500"
      >
        <v-card class="popup add_store_popup" align="center" justify="center">
          <v-row >
            <v-col>
              <span v-text="confirmBox.msg"></span>
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-center">
            <v-btn
                @click="confirm"
                text icon class="btn"
            >
                {{$t('Yes')}}
            </v-btn>
            <v-btn
                @click="$emit('closeConfirmBox')"
                text icon class="btn"
            >
                {{$t('No')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
export default {
  name: 'ConfirmBox',
  props: {
    confirmBox: {
      type: Object,
      required: true,
      default () {
        return {
          confirmBox: {
            visible: false,
            msg: ''
          }
        }
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    confirm () {
      this.$emit('confirm')
      this.$emit('closeConfirmBox')
    }
  }
}
</script>

<style>
</style>
